import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from 'react';
import { useNavItemsWidth } from "./hooks/useNavItemsWidth/useNavItemsWidth";
import { TrackingContext } from "./hooks/useTracking/useTracking";
import * as styles from "./DepartmentsNav.styles";
import { DepartmentsNavItem } from "../DepartmentsNavItem/DepartmentsNavItem";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
export var DepartmentsNav = function DepartmentsNav(_ref) {
  var className = _ref.className,
    departments = _ref.departments;
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    _useSiteChromeDynamic2 = _useSiteChromeDynamic.contentOverlay,
    close = _useSiteChromeDynamic2.close,
    open = _useSiteChromeDynamic2.open,
    navRef = _useSiteChromeDynamic.departmentsNavigation.ref;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    openDepartmentIndex = _useState2[0],
    setOpenDepartmentIndex = _useState2[1];
  var listRef = useRef(null);
  var _useNavItemsWidth = useNavItemsWidth(),
    setNavItemRef = _useNavItemsWidth.setNavItemRef;
  return /*#__PURE__*/React.createElement(TrackingContext.Provider, {
    value: {
      navigationData: departments
    }
  }, /*#__PURE__*/React.createElement(_StyledNav, {
    className: className,
    ref: navRef,
    $_css: styles.nav
  }, /*#__PURE__*/React.createElement(_StyledUl, {
    ref: listRef,
    $_css2: styles.list
  }, departments.map(function (department, index) {
    return /*#__PURE__*/React.createElement(DepartmentsNavItem, {
      department: department,
      index: index
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: index,
      openIndex: openDepartmentIndex,
      seo: department.seo,
      setNavClosed: function setNavClosed() {
        setOpenDepartmentIndex(-1);
        close();
      },
      setNavOpen: function setNavOpen(index) {
        var _departments$index;
        setOpenDepartmentIndex(index);
        var openDeptHasChildren = ((_departments$index = departments[index]) === null || _departments$index === void 0 ? void 0 : _departments$index.columns.length) > 0;
        if (openDeptHasChildren && navRef.current) {
          var navBottom = navRef.current.getBoundingClientRect().bottom;
          open(navBottom + window.scrollY);
        }
      },
      setRef: function setRef(ref) {
        return setNavItemRef(ref, index);
      }
    });
  }))));
};
var _StyledNav = _styled("nav")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledUl = /*#__PURE__*/_styled2("ul").withConfig({
  displayName: "DepartmentsNav___StyledUl",
  componentId: "sc-1n4vtmh-0"
})(["", ""], function (p) {
  return p.$_css2;
});